var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-heading-button"},[_c('router-link',{attrs:{"to":_vm.to || { name: _vm.toRoute }}},[_c('icon',{attrs:{"name":"arrow-left","scale":"1.2"}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }